var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',[_c('v-select',{attrs:{"outlined":"","dense":"","items":_vm.items,"label":_vm.$t('message.gender'),"item-text":"name","item-value":"value","clearable":true},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }